import VersionStyle, { InterlinearNumberStyle } from '../html/VersionStyle';
import VersionStyles from '../html/VersionStyles';
import Source from '../sources/Source';
import SourceCode from '../sources/SourceCode';
import SourceStore from '../sources/SourceStore';
import SourceType from '../sources/SourceType';
import Version from './Version';
import VersionGroup from './VersionGroup';
import VersionGroups from './VersionGroups';

export default class VersionBuilder {

    private style: VersionStyle = VersionStyles.default();

    private constructor(private readonly source: Source, private readonly group: VersionGroup) {
    }

    public static create(group: VersionGroup, sources: SourceStore, code: SourceCode, type?: SourceType): VersionBuilder {
        return new VersionBuilder(sources.getSource(code, type), group);
    }

    public static english(sources: SourceStore, code: SourceCode, type?: SourceType): VersionBuilder {
        return this.create(VersionGroups.english, sources, code, type);
    }

    public static international(sources: SourceStore, code: SourceCode, type?: SourceType): VersionBuilder {
        return this.create(VersionGroups.international, sources, code, type);
    }

    public static interlinear(sources: SourceStore, code: SourceCode, type?: SourceType): VersionBuilder {
        return this.create(VersionGroups.interlinear, sources, code, type);
    }

    public hebrew(mergeWith?: VersionStyle): this {
        this.style = VersionStyles.hebrew(mergeWith);
        return this;
    }

    public greek(mergeWith?: VersionStyle): this {
        this.style = VersionStyles.greek(mergeWith);
        return this;
    }

    public parsing(mergeWith?: VersionStyle): this {
        this.style = VersionStyles.parsing(mergeWith);
        return this;
    }

    public transliteration(mergeWith?: VersionStyle): this {
        this.style = VersionStyles.transliteration(mergeWith);
        return this;
    }

    public allowLexiconLookup(): this {
        this.style = Object.assign(this.style, { allowLexiconLookup: true });
        return this;
    }

    public addStandardSequentialNumbers(): this {
        this.style = Object.assign(this.style, { interlinearNumberStyle: InterlinearNumberStyle.AddStandardSequential });
        return this;
    }

    public addAlternateSequentialNumbers(): this {
        this.style = Object.assign(this.style, { interlinearNumberStyle: InterlinearNumberStyle.AddAlternateSequential });
        return this;
    }

    public build(): Version {
        return Version.fromSource(this.source, {
            group: this.group,
            style: this.style
        });
    }
}
